import React from 'react';
import { styled } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';

import { type SearchSelectFieldProps } from 'app/main/components/fields/SearchSelectField';
import { useSettings } from 'app/main/components/hooks';
import SearchSelectField from 'app/main/components/fields/SearchSelectField';

import type { EditInputCellParams } from '../DetailsSectionTableInputCells';

type SearchSelectEditInputCellParams = EditInputCellParams & Pick<SearchSelectFieldProps, 'systable' | 'filters'>;

const SearchSelectEditInputCell = styled((props: SearchSelectEditInputCellParams) => {
	const { settings } = useSettings(props.systable);
	const apiRef = useGridApiContext();

	// const inputRef = React.useRef<HTMLInputElement>();

	const baseParseValue = newValue => ({ [props.field]: newValue, [`${settings.modu_short}_title`]: newValue });

	function handleChange(_name, newValue) {
		const newRow = (props.parseValue || baseParseValue)(newValue !== null ? newValue : {});
		Object.keys(newRow).forEach(async key =>
			apiRef.current.setEditCellValue({ id: props.id, field: key, value: newRow[key] })
		);
		apiRef.current.updateRows([{ ...props.row, ...newRow }]);
	}

	// React.useEffect(() => {
	// 	if (props.hasFocus) inputRef.current?.focus();
	// }, [props.hasFocus]);

	return (
		<SearchSelectField
			className={props.className}
			name={props.field}
			systable={props.systable}
			value={props.value}
			filters={props.filters}
			isEdit
			sendChange={handleChange}
		/>
	);
})(({ theme }) => ({
	width: '100%',
	height: '100%',
	'& > .MuiTextField-root': {
		height: '100%',
		'& > .MuiInputBase-root': {
			height: '100%',
			paddingTop: 0,
			borderRadius: 0,
			'& > .MuiInputBase-input': {
				// paddingLeft: 0,
				paddingRight: theme.spacing(3)
			}
		}
	}
}));

export default React.memo(SearchSelectEditInputCell);
